<p-treeSelect [showClear]="true" placeholder="- - -" [ngModel]="selected" [selectionMode]="selectionMode"
              (ngModelChange)="setMapId($event)" [options]="data"></p-treeSelect>
